export default __webpack_public_path__ + "static/media/rps2.06471433.jpeg";